import {Pipe, PipeTransform} from "@angular/core";
import {CallStatus} from "../../model/callStatus";

@Pipe({name: 'callStatus'})
export class CallStatusPipe implements PipeTransform {
    transform(value: any) {
        return CallStatus[value];
    }
}
